export default "__VITE_ASSET__mpmgTctn__"